import styled from "@emotion/styled"
import { readableColor } from "polished"

import Panel from "@components/panel"

import { scale, rhythm } from "@utils/typography"

const Label = styled.strong`
  display: inline-block;
  ${scale(1 / 4)};
  margin-bottom: ${rhythm(1)};
`

const Text = styled.p`
  ${scale(1 / 8)};
  margin-bottom: 0;
`

const IconLink = styled.a`
  align-items: center;
  color: ${props =>
    props.colour ? props.colour : readableColor(props.theme.colours.primary)}};
  display: flex;
  margin-bottom: ${rhythm(1 / 8)};
  justify-content: center;
  & > svg {
    height: ${rhythm(3 / 4)};
    margin-right: ${rhythm(1 / 2)};
  }
`

const Wrapper = styled(Panel)`
  text-align: center;

  a,
  & {
    color: ${props => readableColor(props.theme.colours.primary)}!important;
  }
`

export { IconLink, Label, Text, Wrapper }
